import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { ContextMenu } from 'react-contextmenu';
import './react-contextmenu.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as contextMenuAction from 'react-contextmenu/modules/actions.js';

// DataTables core - MUST load first
import 'datatables.net';

// DataTables Bootstrap styling
import 'datatables.net-bs/css/dataTables.bootstrap.css';
import 'datatables.net-bs';

// DataTables Buttons plugin
import 'datatables.net-buttons';
import 'datatables.net-buttons-bs';
import 'datatables.net-buttons-bs/css/buttons.bootstrap.min.css';

// DataTables Select plugin
import 'datatables.net-select-bs/css/select.bootstrap.min.css';
import 'datatables.net-select';

// DataTables RowGroup plugin
import 'datatables.net-rowgroup';
import 'datatables.net-rowgroup-bs/css/rowGroup.bootstrap.min.css';

import './datatable-sorting';
import { history } from '../../store';

class DataTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pageIndex: 0,
            selectedRowIndex: undefined,
            initialize: true
        };
        this.selectedItems = [];
        this.initialize = this.initialize.bind(this);
        this.destroy = this.destroy.bind(this);
        this.reloadCurrentState = this.reloadCurrentState.bind(this);
        this.getDataFromLocalStorage = this.getDataFromLocalStorage.bind(this);
    }

    componentDidMount() {
        this.initialize();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!nextState.initialize && !this.state.initialize) {
            let selectedRowIndex = undefined;

            if (this.state.selectedRowIndex !== nextState.selectedRowIndex) {
                selectedRowIndex = nextState.selectedRowIndex;
            }

            if (
                nextProps.id !== this.props.id ||
                nextProps.data.length !== this.props.data.length ||
                nextProps.columns.length !== this.props.columns.length ||
                nextProps.data !== this.props.data
            ) {
                this.reloadTableData(
                    nextProps.id,
                    nextProps.data,
                    nextProps.columns,
                    history,
                    selectedRowIndex
                );
            } else {
                this.updateTable(
                    nextProps.id,
                    nextProps.data,
                    nextProps.columns,
                    history,
                    selectedRowIndex
                );
            }
        }
        return false;
    }

    initialize() {
        let table = this.refs.main;

        let _this = this;

        const {
            id,
            showButtons,
            buttons,
            data,
            columns,
            sortable,
            order,
            pageable,
            serverSide,
            ajax,
            columnFormat,
            rowFormat,
            rowGroup,
            checkBoxSelection,
            selection,
            onSelectedItems,
            onDoubleClick,
            singleSelection,
            contextMenu
        } = this.props;

        const tableConfig = {
            id,
            dom: this.createDOM(),
            lengthMenu: [[10, 25, 50, -1], [10, 25, 50, 'All']],
            processing: true,
            buttons: showButtons ? buttons : [],
            data: data,
            columns: columns,
            ordering: sortable,
            order: order,
            paging: pageable,
            serverSide: serverSide,
            ajax: ajax,
            columnDefs: columnFormat,
            createdRow: rowFormat,
            rowGroup: rowGroup,
            stateSave: true,
            stateSaveCallback: function(settings, data) {
                if (!_this.state.initialize) {
                    const localData = _this.getDataFromLocalStorage(
                        history,
                        id
                    );

                    if (
                        localData !== null &&
                        localData !== undefined &&
                        localData.selectedRowIndex !== undefined
                    )
                        data.selectedRowIndex = localData.selectedRowIndex;

                    localStorage.setItem(
                        'DataTables_MLP' +
                            history.location.pathname +
                            (id ? '#' + id : ''),
                        JSON.stringify(data)
                    );
                }
            },
            stateLoadParams: function(settings, data) {
                // Validate that the saved state matches the current column count
                if (data && data.columns && columns && data.columns.length !== columns.length) {
                    // Column count mismatch - clear the invalid state
                    console.warn('DataTable state column mismatch detected, clearing saved state');
                    return false;
                }
            }
        };

        // Only add select option if selection is enabled to avoid select plugin initialization issues
        if (selection) {
            tableConfig.select = 'multi';
        } else if (checkBoxSelection) {
            tableConfig.select = { style: 'multi', selector: 'td:first-child' };
        } else if (singleSelection) {
            tableConfig.select = singleSelection;
        }

        $(table).DataTable(tableConfig);

        if (selection) {
            $(table, 'tbody').on('click', 'tr', function() {
                if (
                    this._DT_RowIndex !== undefined &&
                    !this.classList.contains('disabled')
                ) {
                    const rowId = this._DT_RowIndex;

                    const localData = _this.getDataFromLocalStorage(
                        history,
                        id
                    );

                    if (localData !== null && localData !== undefined)
                        localData.selectedRowIndex = rowId;

                    if (
                        history !== null &&
                        history !== undefined &&
                        !_this.state.initialize
                    ) {
                        localStorage.setItem(
                            'DataTables_MLP' +
                                history.location.pathname +
                                (id ? '#' + id : ''),
                            JSON.stringify(localData)
                        );
                    }

                    _this.setState({ selectedRowIndex: rowId });
                    const selectedItem = _this.props.data[rowId];
                    const index = $.inArray(selectedItem, _this.selectedItems);

                    if (index === -1) {
                        _this.selectedItems.push(selectedItem);
                    } else {
                        _this.selectedItems.splice(index, 1);
                    }

                    $(this).toggleClass('selected');
                    onSelectedItems(_this.selectedItems);
                }
            });
        }

        if (checkBoxSelection) {
            $(table, 'tbody').on('click', 'tr > td:first-child', function() {
                if (
                    this._DT_CellIndex !== undefined &&
                    !this.parentNode.classList.contains('disabled')
                ) {
                    const rowId = this._DT_CellIndex.row;

                    const localData = _this.getDataFromLocalStorage(
                        history,
                        id
                    );

                    if (localData !== null && localData !== undefined)
                        localData.selectedRowIndex = rowId;

                    if (
                        history !== null &&
                        history !== undefined &&
                        !_this.state.initialize
                    ) {
                        localStorage.setItem(
                            'DataTables_MLP' +
                                history.location.pathname +
                                (id ? '#' + id : ''),
                            JSON.stringify(localData)
                        );
                    }

                    _this.setState({ selectedRowIndex: rowId });
                    const selectedItem = _this.props.data[rowId];
                    const index = $.inArray(selectedItem, _this.selectedItems);

                    if (index === -1) {
                        _this.selectedItems.push(selectedItem);
                    } else {
                        _this.selectedItems.splice(index, 1);
                    }

                    $(this.parentNode).toggleClass('selected');
                    onSelectedItems(_this.selectedItems);
                }
            });

            $('th.select-checkbox').css('cursor', 'pointer');
            $(table, 'tbody').on('click', 'th.select-checkbox', function() {
                let dataTable = $(table).DataTable();
                _this.selectedItems = [];
                if (!$('th.select-checkbox').hasClass('selected')) {
                    dataTable.rows(':not(.disabled, .hidden)').select();
                    let tableData = dataTable
                        .rows(':not(.disabled, .hidden)')
                        .data();
                    for (let i = 0; i < tableData.length; i++) {
                        _this.selectedItems.push(tableData[i]);
                    }
                    onSelectedItems(_this.selectedItems);
                } else {
                    dataTable.rows().deselect();
                    onSelectedItems(_this.selectedItems);
                }
                $('th.select-checkbox').toggleClass('selected');
            });
        }

        if (onDoubleClick) {
            $(table, 'tbody').on('dblclick', 'tr', function() {
                if (this._DT_RowIndex !== undefined) {
                    const rowId = this._DT_RowIndex;
                    const data = _this.props.data[rowId];
                    onDoubleClick(data);
                }
            });
        }

        if (singleSelection) {
            $(table, 'tbody').on('click', 'tr', function() {
                if (!this.classList.contains('disabled')) {
                    if ($(this).hasClass('selected')) {
                        $(this).removeClass('selected');
                        _this.selectedItems = [];
                        let localData = _this.getDataFromLocalStorage(
                            history,
                            id
                        );

                        delete localData.selectedRowIndex;

                        localStorage.setItem(
                            'DataTables_MLP' +
                                history.location.pathname +
                                (id ? '#' + id : ''),
                            JSON.stringify(localData)
                        );

                        _this.setState({ selectedRowIndex: null });

                        onSelectedItems(_this.selectedItems);
                    } else {
                        $(table)
                            .find('tr.selected')
                            .removeClass('selected');
                        $(this).addClass('selected');

                        if (this._DT_RowIndex !== undefined) {
                            let rowId = this._DT_RowIndex;

                            const localData = _this.getDataFromLocalStorage(
                                history,
                                id
                            );

                            if (localData !== null && localData !== undefined)
                                localData.selectedRowIndex = rowId;

                            if (
                                history !== null &&
                                history !== undefined &&
                                !_this.state.initialize
                            ) {
                                localStorage.setItem(
                                    'DataTables_MLP' +
                                        history.location.pathname +
                                        (id ? '#' + id : ''),
                                    JSON.stringify(localData)
                                );
                            }

                            _this.setState({ selectedRowIndex: rowId });

                            let selectedItem = _this.props.data[rowId];

                            _this.selectedItems = [];
                            _this.selectedItems.push(selectedItem);
                            onSelectedItems(_this.selectedItems);
                        }
                    }
                }
            });
        }

        if (contextMenu) {
            $(table, 'tbody').on('contextmenu', 'tr', function(event) {
                $(table)
                    .find('tr.selected')
                    .removeClass('selected');
                $(this).addClass('selected');
                if (this._DT_RowIndex !== undefined) {
                    let rowId = this._DT_RowIndex;

                    const localData = _this.getDataFromLocalStorage(
                        history,
                        id
                    );

                    if (localData !== null && localData !== undefined)
                        localData.selectedRowIndex = rowId;

                    if (
                        history !== null &&
                        history !== undefined &&
                        !_this.state.initialize
                    ) {
                        localStorage.setItem(
                            'DataTables_MLP' +
                                history.location.pathname +
                                (id ? '#' + id : ''),
                            JSON.stringify(localData)
                        );
                    }

                    _this.setState({ selectedRowIndex: rowId });
                    let selectedItem = _this.props.data[rowId];
                    _this.selectedItems = [];
                    _this.selectedItems.push(selectedItem);
                    onSelectedItems(_this.selectedItems);

                    _this.handleContextClick(event, contextMenu.props.rowId);
                }
            });
        }

        this.setState({ initialize: false });

        const localData = this.getDataFromLocalStorage(history, id);

        this.reloadCurrentState(localData, true, _this.state.selectedRowIndex);
    }

    destroy() {
        let table = this.refs.main;

        $(table)
            .DataTable()
            .destroy();
    }

    createDOM() {
        const { pageable, showButtons, searchable } = this.props;
        let row = "<'row'";

        if (pageable) {
            if (showButtons) {
                row += "<'col-sm-5'l><'col-sm-4 text-right'B>";
            } else {
                row += "<'col-sm-9'l>";
            }
        } else if (showButtons) {
            row += "<'col-sm-9 text-left'B>";
        }

        if (searchable) {
            row += "<'col-sm-3'f>";
        }

        row += '>';

        if (pageable) {
            row += 'tip';
        }

        return row;
    }

    reloadTableData(id, names, colnames, history, selectedRowIndex) {
        const localData = this.getDataFromLocalStorage(history, id);
        const table = this.refs.main;

        let datatable = $(table).DataTable();
        let tableHeader = $(datatable.column(0).header());

        tableHeader.removeClass('selected');
        this.selectedItems = [];
        datatable.clear();
        datatable.rows.add(names);
        datatable.columns = colnames;
        datatable.draw();

        this.reloadCurrentState(localData, true, selectedRowIndex);
    }

    updateTable(id, names, colnames, history, selectedRowIndex) {
        const localData = this.getDataFromLocalStorage(history, id);
        const table = this.refs.main;
        const datatable = $(table).DataTable();

        datatable.columns.adjust();
        datatable.rows().every(function() {
            const oldNameData = this.data();
            const newNameData = names.filter(nameData => {
                return nameData.name === oldNameData.name;
            });

            if (oldNameData.nickname !== newNameData.nickname) {
                this.data(newNameData);
            }

            return true;
        });

        datatable.draw();

        this.reloadCurrentState(localData, false, selectedRowIndex);
    }

    reloadCurrentState(localData, isPageLength, selectedRowIndex) {
        if (localData !== undefined && localData !== null) {
            const table = this.refs.main;
            const datatable = $(table).DataTable();

            if (isPageLength) {
                datatable.page.len(localData.length).draw(false);
            }

            const order = localData.order;
            const search = localData.search.search;
            const pageIndex = localData.start / localData.length;

            datatable.order(order).draw(false);
            datatable.search(search).draw(false);
            datatable.page(pageIndex).draw(false);

            if (localData.selectedRowIndex !== undefined) {
                /*datatable
                    .row(localData.selectedRowIndex, { page: 'current' })
                    .select();*/
                datatable.rows({ selected: true }.deselect);
            }
        }
    }

    getDataFromLocalStorage(history, id) {
        let localData = null;
        if (history !== null && history !== undefined) {
            const localPath = history.location.pathname + (id ? '#' + id : '');
            localData = JSON.parse(
                localStorage.getItem('DataTables_MLP' + localPath)
            );
        }

        return localData;
    }

    handleContextClick(event, id) {
        event.preventDefault();
        event.stopPropagation();

        const x = event.clientX || (event.touches && event.touches[0].pageX);
        const y = event.clientY || (event.touches && event.touches[0].pageY);

        let showMenuConfig = {
            position: { x, y },
            id: id
        };
        contextMenuAction.showMenu(showMenuConfig);
    }

    render() {
        const { id, contextMenu } = this.props;

        return (
            <div className="table-responsive">
                <table
                    id={id}
                    ref="main"
                    className="table table-hover table-bordered table-striped data-table-back"
                    cellSpacing="0"
                    width="100%"
                />
                {contextMenu}
            </div>
        );
    }
}

DataTable.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    sortable: PropTypes.bool,
    pageable: PropTypes.bool,
    checkBoxSelection: PropTypes.bool,
    selection: PropTypes.bool,
    searchable: PropTypes.bool,
    showButtons: PropTypes.bool,
    buttons: PropTypes.array,
    onSelectedItems: PropTypes.func,
    onDoubleClick: PropTypes.func,
    singleSelection: PropTypes.bool,
    serverSide: PropTypes.bool,
    ajax: PropTypes.string,
    columnFormat: PropTypes.array,
    rowFormat: PropTypes.func,
    rowGroup: PropTypes.object,
    order: PropTypes.array,
    contextMenu: PropTypes.instanceOf(ContextMenu),
    id: PropTypes.string,
    history: PropTypes.object
};

DataTable.defaultProps = {
    sortable: false,
    pageable: false,
    checkBoxSelection: false,
    selection: false,
    searchable: false,
    singleSelection: false,
    contextMenu: null,
    showButtons: false,
    buttons: [],
    serverSide: false,
    columnFormat: null,
    rowFormat: null,
    rowGroup: null,
    order: [['0', 'desc']],
    id: null,
    history: null
};

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/DataTable/index.js